ixModuleRouting("impactx.admindashboard", {
    "/admindashboard": {
        template: "<ixa-admin-dashboard></ixa-admin-dashboard>",
        workspace: "admin",
    },
    "/extractedfiles": {
        template: '<ixa-extracted-files-list></ixa-extracted-files-list>',
        process: 'AITrainingProcess',
        workspace: 'admin'
    },
    "/extractedfilesdetails/:jobId": {
        template: '<ixa-extracted-data-detail></ixa-extracted-data-detail>',
        process: 'AITrainingProcess',
        workspace: 'admin'
    },
});
